import React from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { iconCheckCircle } from '../../assets/icons/generated'
import { iconPanoramaFisheye } from '../../assets/icons/generated'
import { spacing } from '../../theme'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'
import { RadioGroupProps } from './radio-group.props'

const RowStyle: ViewStyle = {
  flexDirection: 'row',
  marginHorizontal: spacing[4],
  justifyContent: 'space-between',
  alignContent: 'center',
  paddingVertical: spacing[3],
}

export function RadioGroupWeb(props: RadioGroupProps) {
  // grab the props
  const { style, options, value, onPress, rowStyleOverride, multiple } = props

  if (multiple) {
    return (
      <View style={{ ...style }}>
        {options.map((option) => {
          return (
            <View key={option.label} style={{ ...RowStyle, ...rowStyleOverride }}>
              <Text variant="label" text={option.label} tx={option.labelTx} />
              <TouchableOpacity
                accessibilityLabel={value ? 'Toggle Off' : 'Toggle On'}
                onPress={() => onPress(option.value)}
                hitSlop={{ top: 20, bottom: 20, left: 50, right: 50 }}
              >
                {Array.isArray(value) && value.includes(option.value) ? (
                  <SvgIcon src={iconCheckCircle} color="black" size={24} />
                ) : (
                  <SvgIcon src={iconPanoramaFisheye} color="black" size={24} />
                )}
              </TouchableOpacity>
            </View>
          )
        })}
      </View>
    )
  }

  return (
    <View style={{ ...style }}>
      {options.map((option) => {
        return (
          <View key={option.label} style={{ ...RowStyle }}>
            <label style={{ cursor: 'pointer' }} onClick={() => onPress(option.value)}>
              <Text text={option.label} tx={option.labelTx} />
            </label>

            {option.value === value ? (
              <SvgIcon src={iconCheckCircle} color="black" size={24} />
            ) : (
              <TouchableOpacity
                accessibilityRole="radio"
                accessibilityLabel={value ? 'Toggle Off' : 'Toggle On'}
                onPress={() => onPress(option.value)}
                hitSlop={{ top: 20, bottom: 20, left: 50, right: 50 }}
              >
                <SvgIcon src={iconPanoramaFisheye} color="black" size={24} />
              </TouchableOpacity>
            )}
          </View>
        )
      })}
    </View>
  )
}
